import React, {useEffect} from 'react';
import QuoteBlock from '../component/meet-ours';
import Wrapper from "../component/Wrapper";
import SecondBanner from "../component/SecondBanner";
import MissionAbout from "../component/MissionAbout";
import ThirdBanner from "../component/thirdBanner";
import {useDispatch, useSelector} from "react-redux";
import {selectAboutData} from "../store/selectors";
import {getAboutData} from "../store/actions/app";
import {useLocalizedData} from '../hooks/useTranslatedContent';
import Preloader from "../component/Preloader";
import Error404 from "../component/404";

export default function AboutUs() {
    const dispatch = useDispatch();
    const aboutData = useSelector(selectAboutData);
    const status = useSelector(state => state.app.status.aboutData);
    const {getLocalizedFirstItem} = useLocalizedData(aboutData);

    useEffect(() => {
        if (status === 'idle') dispatch(getAboutData());
    }, [dispatch, status]);

    if (status === 'loading' || status === 'idle') {
        return (
            <Preloader/>
        );
    }

    if (status === 'failed' || !aboutData) {
        return <Error404 />;
    }
    const firstBannerItem = getLocalizedFirstItem('firstBanner');


    return (
        <Wrapper>
            <section
                className="py-40 w-full relative bg-no-repeat bg-cover bg-center"
                id="home"
                style={{
                    backgroundImage: `url(${firstBannerItem.img})`,
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                <div className="container relative flex flex-col justify-start items-start ">
                    {firstBannerItem.description && (
                        <div>
                        <h1 className={'font-medium leading-normal text-5xl text-white'}>{firstBannerItem.titleBanner}</h1>
                        <p
                        className="text-2xl text-white mt-4 max-w-3xl"
                        dangerouslySetInnerHTML={{__html: firstBannerItem.description}}
                />
                        </div>
                )}
            </div>
        </section>


    <section className="relative md:py-24 py-16" id="about">
        <QuoteBlock aboutData={aboutData}/>
        <SecondBanner aboutData={aboutData}/>
        <MissionAbout aboutData={aboutData}/>
    </section>

    <ThirdBanner aboutData={aboutData}/>
</Wrapper>
)
    ;
}